exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.view--1n2UbAL1{height:3rem;width:3rem;border:1px solid #96a7bb;border-left:none}.view--1n2UbAL1:hover{cursor:pointer}@media (max-width:599px){.view--1n2UbAL1{height:2.5rem;width:2.5rem}}", ""]);

// exports
exports.locals = {
	"view": "view--1n2UbAL1"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/sign_up/shared/swatch/styles.scss
// module id = 1050
// module chunks = 0